import { render, staticRenderFns } from "./register-agent.vue?vue&type=template&id=7d4b3f1d&scoped=true"
import script from "./register-agent.vue?vue&type=script&lang=js"
export * from "./register-agent.vue?vue&type=script&lang=js"
import style0 from "./register-agent.vue?vue&type=style&index=0&id=7d4b3f1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4b3f1d",
  null
  
)

export default component.exports